import cx from 'classnames';
import { Container, Loader, enums, utils as u } from 'edrolo-ui';

export const Skeleton = () => {
  return (
    <header className={cx(u.py10, u.bgSurface1)}>
      <Container>
        <div className={cx(u.grid, u.gap4)}>
          <Loader.Gradient width={enums.Size.SMALL} />
          <Loader.Gradient width={enums.Size.MEDIUM} />
        </div>
      </Container>
    </header>
  );
};
